import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  query,
  where,
} from "firebase/firestore";

function AdminWithdrawals() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  // ===============================
  // FETCH WITHDRAWALS
  // ===============================
  const fetchWithdrawals = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "withdrawals"));
      const snap = await getDocs(q);

      const withdrawalsData = await Promise.all(
        snap.docs.map(async (docSnap) => {
          const w = { id: docSnap.id, ...docSnap.data() };

          // 🔍 FETCH USER INFO
          const userQuery = query(
            collection(db, "users"),
            where("username", "==", w.username)
          );
          const userSnap = await getDocs(userQuery);

          let fullName = "-";
          let country = "-";

          if (!userSnap.empty) {
            const userData = userSnap.docs[0].data();
            fullName = userData.fullName || "-";
            country = userData.country || "-";
          }

          return { ...w, fullName, country };
        })
      );

      // 🚫 HIDE COMPLETED & CANCELLED
      const filtered = withdrawalsData.filter(
        (w) =>
          w.status !== "success" &&
          w.status !== "rejected" &&
          w.status !== "cancelled" &&
          w.status !== "user_cancelled"
      );

      setWithdrawals(filtered);
    } catch (err) {
      console.error("Error fetching withdrawals:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  // ===============================
  // UPDATE STATUS
  // ===============================
  const updateStatus = async (id, status) => {
    const confirmed = window.confirm(
      `Una uhakika unataka kubadilisha status kuwa "${status}"?`
    );
    if (!confirmed) return;

    try {
      const docRef = doc(db, "withdrawals", id);
      const withdrawalDoc = await getDoc(docRef);
      if (!withdrawalDoc.exists()) return;

      const withdrawal = withdrawalDoc.data();

      // 🔁 REFUND IF REJECTED
      if (status === "rejected") {
        const userQuery = query(
          collection(db, "users"),
          where("username", "==", withdrawal.username)
        );
        const userSnap = await getDocs(userQuery);

        if (!userSnap.empty) {
          const userDoc = userSnap.docs[0];
          const userData = userDoc.data();

          const balanceField =
            withdrawal.currency === "TSH"
              ? "tshBalance"
              : "usdtBalance";

          const newBalance =
            Number(userData[balanceField] || 0) +
            Number(withdrawal.amount || 0);

          await updateDoc(userDoc.ref, { [balanceField]: newBalance });
        }
      }

      await updateDoc(docRef, { status });
      fetchWithdrawals();
    } catch (err) {
      console.error("Error updating status:", err);
    }
  };

  if (loading) return <p>Loading withdrawals...</p>;

  return (
    <div className="admin-withdrawals">
      <h2>Admin Withdrawals</h2>

      {withdrawals.length === 0 ? (
        <p style={{ color: "red", fontWeight: "bold" }}>
          Hakuna withdrawals za kushughulikia kwa sasa.
        </p>
      ) : (
        <table border="1" cellPadding="6" cellSpacing="0">
          <thead>
            <tr>
              <th>Username</th>
              <th>Full Name</th>
              <th>Country</th>
              <th>Amount</th>
              <th>Net (95%)</th>
              <th>Currency</th>
              <th>Status</th>
              <th>Network</th>
              <th>Phone</th>
              <th>USDT Address</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {withdrawals.map((w) => {
              // ✅ 5% FEE FOR BOTH TSH & USDT
              const netAmount = (Number(w.amount) * 0.95).toFixed(2);

              // 🎨 ROW COLOR
              let bgColor = "transparent";
              if (w.status === "approving") bgColor = "#fff3cd";
              if (w.status === "approved") bgColor = "#d1ecf1";
              if (w.status === "pending") bgColor = "#f8d7da";

              return (
                <tr key={w.id} style={{ backgroundColor: bgColor }}>
                  <td>{w.username}</td>
                  <td>{w.fullName}</td>
                  <td>{w.country}</td>
                  <td>{w.amount}</td>
                  <td>{netAmount}</td>
                  <td>{w.currency}</td>
                  <td>{w.status}</td>
                  <td>{w.network || "-"}</td>
                  <td>{w.currency === "TSH" ? w.phone || "-" : "-"}</td>

                  {/* ✅ USDT ADDRESS */}
                  <td style={{ maxWidth: 220, wordBreak: "break-all" }}>
                    {w.currency === "USDT"
                      ? w.usdtAddress || "—"
                      : "—"}
                  </td>

                  <td>
                    {w.createdAt?.toDate
                      ? w.createdAt.toDate().toLocaleString()
                      : "-"}
                  </td>

                  <td>
                    <button
                      onClick={() => updateStatus(w.id, "approving")}
                      disabled={
                        w.status !== "pending" &&
                        w.status !== "processing"
                      }
                    >
                      Approving
                    </button>

                    <button
                      onClick={() => updateStatus(w.id, "approved")}
                      disabled={w.status !== "approving"}
                    >
                      Approved/Ukaguzi Umepita
                    </button>

                  

                    <button
                      onClick={() => updateStatus(w.id, "rejected")}
                    >
                      Reject
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminWithdrawals;